export default __webpack_public_path__ + "1695227a8dd905c9071ed8b77340c97b.jpg";